import { cn } from '@/shared/lib/utils';
import { MiniProgressBar } from '@/shared/ui';

export interface CapacityBarProps {
  /** Využitá kapacita (obsazenost). */
  used: number;
  /** Celková kapacita. */
  capacity: number;
  /** Šířka mini progress baru v px. Default 34 (tabulka termínů), 40 pro pilulku Rezervace. */
  width?: number;
  /** Zobrazit procento obsazenosti za barem (pilulka Rezervace). */
  showPercent?: boolean;
  className?: string;
}

/**
 * Kompozice mini progress baru a počtů kapacity (`used / cap`) pro plánovací modul. Žije na úrovni modulu (sdílí ji víc
 * submodulů), ne v shared UI – je to doménová kompozice nad shared `MiniProgressBar`.
 */
export function CapacityBar({
  used,
  capacity,
  width = 34,
  showPercent = false,
  className,
}: CapacityBarProps) {
  if (!capacity) {
    return <span className="text-phx-text-muted">—</span>;
  }
  const pct = Math.round((used / capacity) * 100);
  return (
    <span className={cn('gap-phx-2 inline-flex items-center whitespace-nowrap', className)}>
      <span className="tabular-nums">
        <strong>{used}</strong> / {capacity}
      </span>
      <MiniProgressBar value={used} max={capacity} width={width} />
      {showPercent ? (
        <span className="text-phx-xs text-phx-text-muted tabular-nums">{pct} %</span>
      ) : null}
    </span>
  );
}
